import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { erpApi } from '../../api/erp';
import { useErpAuth } from '../../context/ErpAuthContext';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { GeneratePasswordAction } from '../../components/ui/GeneratePasswordAction';
import './erp.css';

export function ErpForceChangePasswordPage() {
  const { refreshUser, logout } = useErpAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError('La nueva contraseña debe tener al menos 8 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('La nueva contraseña y su confirmación no coinciden.');
      return;
    }
    if (newPassword === currentPassword) {
      setError('La nueva contraseña debe ser distinta de la provisional.');
      return;
    }

    setLoading(true);
    try {
      await erpApi.changePassword(currentPassword, newPassword);
      await refreshUser();
      navigate('/erp', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo cambiar la contraseña');
    } finally {
      setLoading(false);
    }
  }

  async function handleLogout() {
    await logout();
    navigate('/erp/login', { replace: true });
  }

  return (
    <div className="erp-login-page">
      <Card className="erp-login-card">
        <h1>Cambia tu contraseña</h1>
        <p style={{ color: 'var(--color-text-muted)', marginTop: '0.25rem' }}>
          Tu cuenta usa una contraseña provisional. Elige una nueva para continuar.
        </p>
        <form onSubmit={handleSubmit} style={{ marginTop: '1.25rem', display: 'grid', gap: '0.75rem' }}>
          <Input
            label="Contraseña provisional"
            type="password"
            autoComplete="current-password"
            required
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          <Input
            label="Nueva contraseña"
            type="password"
            autoComplete="new-password"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            hint="Mínimo 8 caracteres"
            showPasswordToggle
            labelAction={
              <GeneratePasswordAction
                onGenerate={(pwd) => {
                  setNewPassword(pwd);
                  setConfirmPassword(pwd);
                }}
              />
            }
          />
          <Input
            label="Repite la nueva contraseña"
            type="password"
            autoComplete="new-password"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {error ? <p style={{ color: 'var(--color-danger)', margin: 0 }}>{error}</p> : null}
          <Button type="submit" disabled={loading}>
            {loading ? 'Guardando…' : 'Guardar y continuar'}
          </Button>
        </form>
        <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
          <button
            type="button"
            onClick={handleLogout}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              color: 'inherit',
              font: 'inherit',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Cerrar sesión
          </button>
        </p>
      </Card>
    </div>
  );
}
